export class IdBuilderUtils{

    /**
     * Generates an oder id from a given document id
     *
     * @param id Id of a document or property from which the order id should be generated
     * @return generated order id
     */
    public static buildOrderIdFromDocumentOrPropertyId(id: string): string{
        const firstDashIndex = id.indexOf("-");
        const secondDashIndex = id.indexOf("-", firstDashIndex + 1);
        const prefix = id.substring(0, secondDashIndex + 1);
        const suffix = "0";
        return prefix + suffix;
    }

    /**
     * Generates a property if from a given document id
     *
     * @param documentId Id of a document from which the order id should be generated
     * @return generated property id
     */
    public static buildPropertyIdFromDocumentId(documentId: string): string{
        const lastDashIndex = documentId.lastIndexOf("-");
        return documentId.substring(0, lastDashIndex);
    }

}
